import { render, staticRenderFns } from "./CreateSign.vue?vue&type=template&id=19398c37&scoped=true&lang=html"
import script from "./CreateSign.vue?vue&type=script&lang=js"
export * from "./CreateSign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19398c37",
  null
  
)

export default component.exports